export const endpoint = {
  roleData: 'user/current/defaultvalues/role',
  loadDefaultValues: 'user/current/defaultValues',
  saveDefaultValues: 'user/current/defaultValues'
};

export const userOptions = {
  defaultValues: {
    optionsCollections: 'user/defaultValues/optionsCollections/options',
    caseTypes: 'user/defaultValues/caseTypes/options',
    values: (optionsCollectionId) =>
      `user/defaultValues/optionsCollection/${optionsCollectionId}/options`,
    valuesFields: (optionsCollectionId) => `user/defaultValues/optionsCollection/${optionsCollectionId}/fields/options`
  }
};
